<template>
  <div>
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">New Recruits Approvals</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Employee</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- stats cards -->
          <div class="row">
            <!-- Total Pending Approvals -->
            <div class="col-lg-4 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Pending Approvals</p>
                      <h5 class="mb-0">512</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="mdi mdi-clock-outline"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Approved Recruits -->
            <div class="col-lg-4 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Approved Recruits</p>
                      <h5 class="mb-0">1,235</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="mdi mdi-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Rejected Applications -->
            <div class="col-lg-4 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Rejected Applications</p>
                      <h5 class="mb-0">128</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                        <i class="mdi mdi-close-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of stats -->

          <!-- Notification Toast -->
          <div class="position-fixed bottom-0 end-0 p-3" style="z-index: 11">
            <div id="notification-toast" class="toast hide" :class="{'show': message}" role="alert" aria-live="assertive" aria-atomic="true">
              <div class="toast-header" :class="message && message.includes('success') ? 'bg-success text-white' : 'bg-danger text-white'">
                <strong class="me-auto">{{ message && message.includes('success') ? 'Success' : 'Error' }}</strong>
                <button type="button" class="btn-close" @click="message = ''" aria-label="Close"></button>
              </div>
              <div class="toast-body">
                {{ message }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input type="text" class="form-control bg-light border-light rounded"
                                 placeholder="Search..." @input="handleSearch">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div class="d-flex align-items-center me-3 pe-3">
                        <div>
                          <div class="float-end d-flex ">
                            <div class="input-group fw-semibold text-uppercase me-3">
                              <label class="input-group-text text-uppercase">Department</label>
                              <select class="form-select" style="width: 200px;" @change="handleDepartmentChange">
                                <option selected="selected" value="">All Departments</option>
                                <option v-for="department in departments" :key="department.id" :value="department.id">
                                  {{ department.departmentName }}
                                </option>
                              </select>
                            </div>

                            <div class="input-group fw-semibold text-uppercase">
                              <label class="input-group-text text-uppercase">FROM:</label>
                              <input class="form-control form-control-sm" type="date" v-model="dateFrom" @change="handleDateChange">
                            </div>

                            <div class="input-group fw-semibold text-uppercase">
                              <label class="input-group-text text-uppercase">TO:</label>
                              <input class="form-control form-control-sm" type="date" v-model="dateTo" @change="handleDateChange">
                            </div>
                          </div>
                        </div>
                      </div>
                      <button @click="downloadReport" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                        <i class="bx bxs-download font-size-16"></i> <span class="pl-1 d-md-inline">Download Report</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div v-if="isLoading" class="text-center my-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading employee data...</p>
                  </div>

                  <!-- Debug message if data loading failed -->
                  <div v-if="message" class="alert alert-warning">
                    {{ message }}
                  </div>

                  <div v-if="!isLoading" class="table-responsive">
                    <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                      <thead class="table-light">
                      <tr class="table-dark">
                        <th scope="col">App No.</th>
                        <th scope="col">Name</th>
                        <th scope="col">ID No.</th>
                        <th scope="col">Contract Type</th>
                        <th scope="col">Proposed Salary</th>
                        <th scope="col">Department</th>
                        <th scope="col">Designation</th>
                        <th scope="col">Date Added</th>
                        <th scope="col">Submitted By</th>
                        <th scope="col" class="text-right">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in employeeData" :key="index">
                        <th>{{ item.id }}</th>
                        <td>
                          <a @click="gotTo(item.id,'employee-approvals-new-verification')" href="javascript: void(0);">
                            {{ item.firstName }} {{ item.lastName }}
                          </a>
                        </td>
                        <td>{{ item.nationalId }}</td>
                        <td>{{ item.contractType }}</td>
                        <td>KES {{ item.salary || '0' }}</td>
                        <td>{{ item.department }}</td>
                        <td>{{ item.designation }}</td>
                        <td>{{ item.dateCreated }}</td>
                        <td>{{ item.createdBy }}</td>
                        <td class="text-right">
                          <a @click="gotTo(item.id,'employee-approvals-new-verification')" href="javascript: void(0);" class="btn btn-sm btn-success mx-2">
                            Verify & Approve
                          </a>
                        </td>
                      </tr>
                      <tr v-if="employeeData.length === 0 && !isLoading">
                        <td colspan="10" class="text-center">No employee records found</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">2024</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>


<script>
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, execute, getRight } from "@/api";

export default {
  name: "EmployeeApprovals",
  components: { NavigationBar },
  data() {
    return {
      alert: {
        success: false,
        info: false,
        failed: false
      },
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      employeeData: [],
      departments: [],
      selectedDepartment: "",
      dateFrom: "",
      dateTo: "",
      searchKeyword: "",
      isLoading: false,
      message: ""
    };
  },
  mounted() {
    // Load departments first, then employee data
    this.getDepartments();
    this.getEmployeeData();
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },
    gotTo(employeeDataId, route) {
      sessionStorage.setItem('employeeDataId', employeeDataId);
      this.$router.push(route);
    },

    // Get list of departments
    getDepartments() {
      const data = new FormData();
      data.append("function", "getDepartments");

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.departments)) {
                this.departments = res.data.data.departments;
              } else {
                console.log("No departments data found or incorrect data format");
              }
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // Handle department selection change
    handleDepartmentChange(event) {
      this.selectedDepartment = event.target.value;
      this.getEmployeeData();
    },

    // Handle search input
    handleSearch(event) {
      this.searchKeyword = event.target.value;
      this.getEmployeeData();
    },

    // Handle date filter changes
    handleDateChange() {
      this.getEmployeeData();
    },

    // Get employee data with filters
    getEmployeeData() {
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getEmployeeData");

      // Add filters if selected
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      if (this.searchKeyword) {
        data.append("keyword", this.searchKeyword);
      }
      if (this.dateFrom) {
        data.append("dateFrom", this.dateFrom);
      }
      if (this.dateTo) {
        data.append("dateTo", this.dateTo);
      }

      execute(data, authUrl)
          .then((res) => {
            this.isLoading = false;
            console.log("API Response:", res.data); // For debugging

            if (res.data && res.data.success && res.data.data && res.data.data.employeeData) {
              // Map the response data to our display format
              this.employeeData = res.data.data.employeeData.map((item) => {
                // Parse the 'data' field - handle potential JSON parsing errors
                let parsedData = {};
                try {
                  parsedData = item.data ? JSON.parse(item.data) : {};
                } catch (error) {
                  console.error("Error parsing JSON data:", error);
                }

                // Safely access nested properties with fallbacks
                return {
                  id: item.id || "N/A",
                  firstName: (parsedData.employeeData && parsedData.employeeData.firstName) || "N/A",
                  lastName: (parsedData.employeeData && parsedData.employeeData.lastName) || "N/A",
                  nationalId: (parsedData.employeeData && parsedData.employeeData.nationalId) || "N/A",
                  contractType: (parsedData.extraDetails && parsedData.extraDetails.employmentType) || "N/A",
                  salary: (parsedData.bankDetails && parsedData.bankDetails.netSalary) || "0",
                  department: (parsedData.employmentDetails && parsedData.employmentDetails.department) || "N/A",
                  designation: (parsedData.employmentDetails && parsedData.employmentDetails.designation) || "N/A",
                  dateCreated: item.dateCreated || "N/A",
                  createdBy: item.createdBy || "N/A"
                };
              });

              console.log("Processed Employee Data:", this.employeeData); // For debugging
            } else {
              this.message = res.data ? res.data.message || "Failed to get data" : "No response data";
              console.error("API Error:", this.message);
              this.employeeData = [];
            }
          })
          .catch((e) => {
            this.isLoading = false;
            this.message = e.message || "An error occurred";
            console.error("API Exception:", e);
            this.employeeData = [];
          });
    },

    // Download report
    downloadReport() {
      const data = new FormData();
      data.append("function", "downloadEmployeeReport");

      // Add filters if selected
      if (this.selectedDepartment) {
        data.append("department", this.selectedDepartment);
      }
      if (this.searchKeyword) {
        data.append("keyword", this.searchKeyword);
      }
      if (this.dateFrom) {
        data.append("dateFrom", this.dateFrom);
      }
      if (this.dateTo) {
        data.append("dateTo", this.dateTo);
      }

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success && res.data.data && res.data.data.reportUrl) {
              // Open report in new window or initiate download
              window.open(res.data.data.reportUrl, '_blank');
            } else {
              this.message = res.data.message || "Failed to generate report";
            }
          })
          .catch((e) => {
            this.message = e.message || "An error occurred while generating report";
          });
    }
  }
};
</script>

<style scoped>

</style>